import { render } from "./SingleSaleForShmone.vue?vue&type=template&id=134c8225&scoped=true"
import script from "./SingleSaleForShmone.vue?vue&type=script&lang=js"
export * from "./SingleSaleForShmone.vue?vue&type=script&lang=js"

import "./SingleSaleForShmone.vue?vue&type=style&index=0&id=134c8225&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134c8225"]])

export default __exports__